export default function SectionContact() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[800px] mx-auto">
        <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden">
          <div className="absolute inset-0 pointer-events-none" style={{
            background: 'radial-gradient(ellipse 80% 60% at 30% 50%, oklch(1 0 0 / 0.1), transparent)',
          }}></div>
          <div className="relative z-10">
            <span className="w-14 h-14 flex items-center justify-center mx-auto bg-background-50/20 rounded-full mb-5">
              <i className="ri-send-plane-fill text-2xl text-background-50"></i>
            </span>
            <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-3">
              投稿爆料
            </h2>
            <p className="text-background-50/80 text-sm md:text-base max-w-lg mx-auto leading-relaxed mb-6">
              手握猛料无处曝光？匿名投稿通道为你敞开。我们承诺严格保密爆料人信息，
              你的每一次勇敢发声，都可能成为改变行业的契机。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-background-50/90 text-sm">
              <span className="flex items-center gap-1.5">
                <i className="ri-mail-line"></i>
                tips@911chigua.com
              </span>
              <span className="hidden sm:inline text-background-50/40">|</span>
              <span className="flex items-center gap-1.5">
                <i className="ri-shield-check-line"></i>
                严格匿名保护
              </span>
              <span className="hidden sm:inline text-background-50/40">|</span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line"></i>
                24小时内响应
              </span>
            </div>
            <a
              href="#contact"
              onClick={(e) => e.preventDefault()}
              className="inline-flex items-center gap-2 mt-6 px-8 py-3 bg-background-50 text-primary-600 font-medium text-sm rounded-full hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-edit-line"></i>
              立即投稿
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}